import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import {Container} from 'react-bootstrap'
import {Form} from 'react-bootstrap'
import {Button} from 'react-bootstrap'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal'

export default function EditTable({table, tableEdit, handleDelete}) {
        
  const { register, handleSubmit, errors } = useForm();
  const [validated, setValidated] = useState(false);
  const [customError, thisError] = useState("")
  
  const [date, setDate] = useState( table.date || null);
  const [name, setName] = useState( table.name || "");
  const [description, setDesc] = useState( table.description || "");
  const [publicT, setP] = useState( table.public || "");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = (data, event, errors) => {
    data.date = date

    event.preventDefault();
    const form = event.target;

    if (form.checkValidity() === false) {
        event.stopPropagation();
        thisError("Check for required fields")
        // console.log("Data Errors: ", data);
    } else {
        // console.log("Data OK: ", data);
        thisError("")
        tableEdit(data)
        
    }
    setValidated(true);
  }

  return (
    <Container className="w3-center tableForm eForm"><br></br>
     <Form onSubmit={handleSubmit(onSubmit)} validated={validated} noValidate> 
        <Form.Group controlId="formBasicDate2">
            <Form.Label>Cupping Date</Form.Label> <br></br>
            <DatePicker
                name="date"
                value={date}
                onChange={v => setDate(v)}
                selected={Date.parse(date)}
                maxLength="11"
                placeholder="Cupping Date" 
                ref={register({required: true, maxLength: 12, name: "date", value: date})}
                required
            />
                <span className="invalid">
                    {customError ? customError : null}
                </span> 
        </Form.Group>
        <Form.Group controlId="formBasicTextF2" >
            <Form.Label>Cupping Table Name</Form.Label>
            <Form.Control type="text" 
            value={name}
            onBlur={e => setName(e.target.value.trim())} 
            onChange={e => setName(e.target.value)} 
            placeholder="Enter Name" minLength="4" maxLength="80" name="name" ref={register({required: true,minLength: 4, maxLength: 81})} required/>    
                <span className="invalid">
                {errors.name && errors.name.type === "minLength" && "Please make sure name is at least 4 characters."}
                {errors.name && errors.name.type === "required" && "Name is required"} 
                </span> 
        </Form.Group>
        <Form.Group controlId="exampleForm.ControlTextarea2">
                <Form.Label>Table Description</Form.Label>
                <Form.Control as="textarea" value={description} 
                onBlur={e => setDesc(e.target.value.trim())} 
                onChange={e => setDesc(e.target.value)} 
                rows="3" maxLength="500" placeholder="Enter Description" name="description" ref={register({required: true, minLength: 1, maxLength: 501})} required/>
                    <span className="invalid">
                    {errors.description && errors.description.type === "minLength" && "Please make sure description is at least 1 character."}
                    {errors.description && errors.description.type === "maxLength" && "Description length max 500 characters"}
                     {errors.description && errors.description.type === "required" && "Description is required"} 
                    </span> 
        </Form.Group>
        
         <Form.Group>
        <Form.Check 
              type="switch"
              id="custom-switch3"
              label="Private / Public"
              name="public"
              defaultChecked={publicT}
              onChange={e => setP(e.target.checked)}
              ref={register({required: false})} 
        /></Form.Group>
        <Button variant="primary" type="submit" size="md"> Save</Button>&nbsp;&nbsp;
        <Button variant="outline-danger" size="sm" onClick={handleShow} style={{border: "none"}}>Delete Table</Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Confirm Table Deletion</Modal.Title>
                </Modal.Header>
                    <Modal.Body><b>Deleting a table is permanent</b>. It will also delete all cuppings that belong to it. You sure?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Go Back</Button>
                    <Button variant="danger" onClick={handleDelete}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        </Form><br></br>
        </Container>
  );
}